var React = require('react');

function ToolInventor (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"className":"fill-background stroke-none","x":"11.6","y":"23","width":"3.6","height":"5.2","key":0}),React.createElement("polygon",{"className":"fill-background stroke-none","points":"12.8,7.7 24.4,7.7 24.4,13.3 11.6,13.3 ","key":1}),React.createElement("rect",{"className":"fill-background stroke-none","x":"15","y":"13.3","width":"5.7","height":"9.6","key":2}),React.createElement("polygon",{"className":"fill-foreground stroke-none","points":"15,13.3 15.5,7.7 20.7,13.3 ","key":3}),React.createElement("polygon",{"className":"fill-foreground stroke-none","points":"20.7,23 15,23 15,28.4 24.4,28.4 24.4,23 ","key":4})]);
}

ToolInventor.defaultProps = {"version":"1.0","id":"Icon","width":"36px","height":"36px","viewBox":"0 0 36 36","xmlSpace":"preserve"};

module.exports = ToolInventor;

ToolInventor.default = ToolInventor;
